import $ from 'jquery'
import { isSP } from './checkScreen'

const $header = $('#header')
const $headerIn = $header.find('.js-header-bg')
const $logo = $header.find('.js-header-logo')
const WHITE_CLASS = '-logo-white'

const randomBg = () => {
  const max = isSP() ? 980 : 650
  const randPos = Math.floor(Math.random() * (max - 0 + 1) + 0)

  $headerIn.css({
    backgroundPosition: `${randPos * -1}px 0px`
  })
}

const smallLogo = () => {
  const SMALL_CLASS = '-is-small'
  const LOCKED_CLASS = '-is-locked'

  $(window).on('scroll', () => {
    if ($('html').hasClass(LOCKED_CLASS) || $header.hasClass(WHITE_CLASS)) {
      return
    }

    if (isSP()) {
      $logo.removeClass(SMALL_CLASS)
      return
    }

    $logo.toggleClass(SMALL_CLASS, $(window).scrollTop() > 100)
  })
}

const headerScrollbar = () => {
  $(window).on('scroll', () => {
    const left = $(window).scrollLeft()
    $header.css({
      left: left * -1
    })
  })
}

const initHeader = () => {
  randomBg()
  smallLogo()
  headerScrollbar()
}

export default initHeader
